interface OnboardingStepContentProps {
  currentStep: {
    component: React.ComponentType<Record<string, unknown>>;
    isFollowUpStep?: boolean;
    key?: string;
  };
  stepProps: Record<string, unknown>;
}

/**
 * Content area component for onboarding steps.
 * Handles different layouts for regular steps vs follow-up steps.
 */
const OnboardingStepContent = ({
  currentStep,
  stepProps,
}: OnboardingStepContentProps) => {
  const CurrentComponent = currentStep.component;

  if (currentStep.isFollowUpStep) {
    // Centered layout for follow-up steps
    return (
      <div className="OnboardingStepContent flex w-full flex-1 flex-col items-center justify-center overflow-y-auto">
        <div className="w-full text-center">
          <CurrentComponent {...stepProps} />
        </div>
      </div>
    );
  }

  // Default layout for other steps
  return (
    <div className="OnboardingStepContent flex min-h-0 flex-1 flex-col items-start justify-start overflow-y-auto">
      <div className="w-full max-w-5xl px-0 lg:px-0">
        <CurrentComponent {...stepProps} />
      </div>
    </div>
  );
};

export default OnboardingStepContent;
